var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroMeuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.147 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 857",
    d: "M1.582 0h66.982a1.471 1.471 0 0 1 1.582 1.326v59.348a1.349 1.349 0 0 1-.988 1.229 1.808 1.808 0 0 1-1.73-.306L52.45 48.649a1.223 1.223 0 0 1-.446-.923V15.2H18.143v32.526a1.223 1.223 0 0 1-.446.923L2.718 61.6a1.808 1.808 0 0 1-1.73.306A1.349 1.349 0 0 1 0 60.674V1.326A1.471 1.471 0 0 1 1.582 0Zm65.4 2.651H3.165V57.4l11.814-10.211V13.876a1.471 1.471 0 0 1 1.582-1.326h37.025a1.471 1.471 0 0 1 1.582 1.326v33.313L66.982 57.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 858",
    d: "M37.838 33.928h2.808v2.809h-2.808v-2.809m-5.574-11.191h9.744a2.806 2.806 0 0 1 2.807 2.808v19.532h4.17v2.808h-27.87v-2.808h8.383V25.545a2.8 2.8 0 0 1 2.766-2.808m0 2.808v19.532h9.744V25.545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroMeuble);
export default __webpack_public_path__ + "static/media/zero-meuble.2fed96b779ff811cef28b15016fbe089.svg";
export { ForwardRef as ReactComponent };